import {
    IonPage, IonContent, IonInput, IonTitle
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import cookieUtil from "../../../../utils/cookieUtil";


class AccountBind extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showTipModal: false,
            showDetail: false,
            token: null,
        }
    }

    showDetail = (type) => {
        const {showDetail} = this.state;
        this.setState({
            showDetail: !showDetail
        })
    }

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
    }

    render() {

        const {showDetail} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className={"phone_top pr border-bottom-e6"}>
                            <div className="top_title">账号绑定</div>
                        </div>
                        <div className="cont_kf">
                            <div className="record pt10">
                                <div className="binding_list clearfix">
                                    <div className="binding_icon"><img
                                        src={require("../../../images/member/kefu/phone/wx_icon.png")}/></div>
                                    <p><span>绑定状态：</span>未绑定</p>
                                    <a href="#" className="btn_s blue">去绑定</a>
                                </div>
                                <div className="binding_list clearfix">
                                    <div className="binding_icon"><img
                                        src={require("../../../images/member/kefu/phone/zfb_icon.png")}/></div>
                                    <p><span>绑定状态：</span>未绑定</p>
                                    <a href="#" className="btn_s blue">去绑定</a>
                                </div>
                                <div className="binding_list clearfix">
                                    <div className="binding_icon"><img
                                        src={require("../../../images/member/kefu/phone/wx_icon.png")}/></div>
                                    <p><span>绑定状态：</span>已绑定</p>
                                    <a className="btn_s gray" onClick={() => this.showDetail(3)}>详情</a>
                                </div>
                                <div className="binding_list clearfix">
                                    <div className="binding_icon"><img
                                        src={require("../../../images/member/kefu/phone/zfb_icon.png")}/></div>
                                    <p><span>绑定状态：</span>已绑定</p>
                                    <a className="btn_s gray" onClick={() => this.showDetail(4)}>详情</a>
                                </div>
                            </div>
                        </div>
                        {/*<!-------------------------灰色透明层--------------------->*/}
                        <div class={showDetail ? "greybackground" : "dn"}
                             onClick={() => this.setState({showDetail: false})}></div>
                        {/*<!-------------------------账号绑定 tc--------------------->*/}
                        <div class={showDetail ? "tc02" : "dn"}>
                            <div class="tc_bg">
                                <a class="close" onClick={() => this.setState({showDetail: false})}>关闭</a>
                                <div class="tc_cont pr">
                                    <div class="tc_title">账号绑定</div>
                                    <p class="pl50">绑定类型：<span class="textGrey9">支付宝绑定</span></p>
                                    <p class="pl50 pb30">绑定账号：<span class="textGrey9">a_103617737163727446</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(AccountBind);
